import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import isMobile from 'helpers/isMobile';
import { FormattedMessage } from 'react-intl';
import lottie from 'lottie-web/build/player/lottie_light';
import logoSpinner from 'images/lottie/CC_Logo_Load.json';
import { Text } from '@companycam/slab-web';

const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const LoadingSpinnerWrapper = styled.div`
  padding: 32px;
  width: 160px;
`;

const LoadingSpinner = ({ redirect }) => {
  const anim = useRef(null);
  const animationContainer = useRef(null);

  useEffect(() => {
    if (!isMobile && animationContainer.current) {
      anim.current = lottie.loadAnimation({
        container: animationContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: logoSpinner,
      });
    }
    return () => anim.current?.destroy();
  }, []);

  useEffect(() => {
    // Wait arbitrary amount of time for complete registration event to finish
    if (!isMobile) {
      setTimeout(() => {
        window.Turbo.visit(redirect);
      }, 5000);
    }
  }, [redirect]);

  return (
    <LoadingWrapper>
      <LoadingSpinnerWrapper ref={animationContainer} />
      <Text as="p" size="m" weight="700" family="heading">
        <FormattedMessage
          id="Onboard.loading.message"
          defaultMessage="Preparing your unlimited cloud storage..."
          description="Interstitial sign up loading message"
        />
      </Text>
    </LoadingWrapper>
  );
};

LoadingSpinner.propTypes = {
  redirect: PropTypes.string.isRequired,
};

export default LoadingSpinner;
